import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';

type Pixels = number;

interface PixelProps {
  height?: Pixels;
  width?: Pixels;
}

interface HeadlineSpacerProps extends PixelProps {}

const getPxValueFromProps =
  (someKey: keyof PixelProps) =>
  (props: HeadlineSpacerProps): string =>
    `${props[someKey]}px`;

export const HeadlineSpacer = styled.hr<HeadlineSpacerProps>`
  width: ${getPxValueFromProps('width')};
  border-width: ${getPxValueFromProps('height')};
  border-color: ${Colors.RADISH};
  border-style: solid;
  margin: 0;
  height: 0;
`;

HeadlineSpacer.defaultProps = {
  height: 3,
  width: 40,
};
